{
  "_format": "hh-sol-artifact-1",
  "contractName": "BreedingManager",
  "sourceName": "contracts/BreedingManager.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_ninjaShrimps",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_yieldToken",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_newOwner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_signingKey",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "BREEDING_ACTIVE",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BREED_PRICE",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DOMAIN_SEPARATOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "SIGNUP_FOR_BREEDING_TYPEHASH",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_male",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_female",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "signature",
          "type": "bytes"
        }
      ],
      "name": "breed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "cert",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "dad",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "mum",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "generation",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "femaleRestHours",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "flipBreedingActive",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        }
      ],
      "name": "getTokenCert",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "dad",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "mum",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "generation",
              "type": "uint256"
            }
          ],
          "internalType": "struct IBreedCert.C",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "lastBreed",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maleRestHours",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nftContract",
      "outputs": [
        {
          "internalType": "contract IBreedable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_breedPrice",
          "type": "uint256"
        }
      ],
      "name": "setBreedPrice",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_ninjaShrimps",
          "type": "address"
        }
      ],
      "name": "setNFTContract",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "maleDuration",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "femaleDuration",
          "type": "uint256"
        }
      ],
      "name": "setParentBreedDelay",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_yield",
          "type": "address"
        }
      ],
      "name": "setYieldToken",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "signingKey",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "yieldToken",
      "outputs": [
        {
          "internalType": "contract INST",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
